"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const uuid_1 = require("uuid");
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function QuestionPhoneSvg(props) {
    const id0 = (0, react_1.useMemo)(() => (0, uuid_1.v4)(), []);
    return react_1.default.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 68, height: 43, viewBox: "0 0 68 43" }, props),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("path", { id: `questionphone-${id0}`, d: "M13.381 12.75L11.59 14.63l-.492-.258c-1.107-.58-2.088-1.32-2.949-2.18-.773-.773-1.409-1.6-1.916-2.43-.308-.503-.508-.903-.61-1.146l-.197-.472 1.743-1.827-2.256-3.04-.415-.559-1.94 2.034c1.256 3.655 3.163 6.563 5.55 8.818 1.564 1.478 3.24 2.586 4.913 3.377.583.276 1.122.491 1.604.654l.178.059 2.242-2.35-3.663-2.559zm-.707-1.458c.297-.311.769-.36 1.12-.114l5.574 3.895-4.099 4.295-.41-.097c-.138-.032-.378-.1-.705-.21-.534-.181-1.127-.418-1.763-.719-1.81-.855-3.616-2.05-5.302-3.643-2.665-2.518-4.77-5.79-6.103-9.905L.842 4.35l.319-.335L3.93 1.113c.344-.361.91-.361 1.254 0 .107.132.107.132.277.363l.646.87L8.686 5.82c.264.357.234.859-.071 1.18L7.223 8.458c.082.152.175.315.28.487.448.73 1.01 1.463 1.693 2.146.629.628 1.329 1.182 2.103 1.642l1.375-1.44z" })),
        react_1.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("rect", { width: 54, height: 14, x: 7, y: 14, fill: "#597EFF", fillRule: "nonzero", opacity: 0.1, rx: 2 }),
            react_1.default.createElement("path", { fill: "#597EFF", fillRule: "nonzero", d: "M16 20v2h-2v-2h2zm4 0v2h-2v-2h2zm4 0v2h-2v-2h2zm4 0v2h-2v-2h2zm4 0v2h-2v-2h2zm4 0v2h-2v-2h2z", opacity: 0.4 }),
            react_1.default.createElement("g", { opacity: 0.6, transform: "matrix(-1 0 0 1 61 11)" },
                react_1.default.createElement("use", { fill: "#597EFF", fillRule: "nonzero", xlinkHref: `#questionphone-${id0}` }))));
}
function QuestionPhone(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(QuestionPhoneSvg, Object.assign({}, svgProps)));
}
exports.default = QuestionPhone;
//# sourceMappingURL=QuestionPhone.js.map